import { useCallback } from 'react'
import { get } from 'lodash'
import { useAuthentication } from '../../contexts/AuthenticationContext'
import fetchJSON from '../resources/fetchJSON'
import { API_HOST_NAME } from '../resources/api/v1/constants'

const generateDefaultDeploymentName = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  return `D${year}${month}${day}-${hours}${minutes}`
}

const useCreateProjectDeployment = (teamSlug) => {
  const { getValidToken } = useAuthentication()

  const createDeployment = useCallback((project) => {
    const projectSlug = get(project, 'slug')
    const nodeIds = get(project, 'nodeIds', [])

    if (!projectSlug) {
      return Promise.reject(new Error('Project slug is required'))
    }

    const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamSlug}/docker/projects/${projectSlug}/deployments`
    const data = {
      deployment: {
        name: generateDefaultDeploymentName(),
        nodeIds
      }
    }

    return getValidToken()
      .then((accessToken) => {
        const options = {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
        return fetchJSON(url, 'POST', options, data)
      })
  }, [teamSlug, getValidToken])

  return { createDeployment }
}

export default useCreateProjectDeployment
